import { str } from "@lit/localize";
//#region src/generated/locales/be.ts
var templates = {
	"pd.form.field.checkRequired": `Selectie vereist`,
	"pd.form.field.invalid.mail": `Ongeldig e-mailadres, gebruik mail@test.be`,
	"pd.form.field.invalid.number": `Alleen nummers toegestaan`,
	"pd.form.field.invalid.phone": `Ongeldig telefoonnummer, gebruik +32 494 667085`,
	"pd.form.field.invalid.vat": `Ongeldig VAT, gebruik BE0123456789`,
	"pd.form.field.rangeRequired": `Bereik vereist`,
	"pd.form.field.required": `Vul dit veld in`,
	"pd.form.field.selectRequired": `Selectie vereist`,
	"pd.form.required.missing": `* Verplicht veld ontbreekt of is onjuist ingevuld`,
	"pd.form.required.valid": `* Verplichte velden ingevuld`,
	"pd.generic-form.unknown": `Onbekend`,
	"pd.input.password.hide": `Wachtwoord verbergen`,
	"pd.input.password.show": `Wachtwoord tonen`,
	"s512f37f2dba563ec": str`Maximaal ${0} tekens`,
	"s8a355eeb33f58c5f": str`Minimaal ${0} tekens`,
	"pd.form.field.invalid.url": `Gültige URL eingeben (z. B. example.com)`,
	"pd.generic-form.no-data": `Keine Daten vorhanden`,
	"pd.generic-form.yes": `Ja`,
	"pd.generic-form.no": `Nein`,
	"pd.suggestion.box.load.data": `Daten werden geladen`,
	"pd.suggestion.box.error.txt": `Technischer Fehler bei der Suche`,
	"pd.suggestion.box.add.new": str`"${0}" neu anlegen`
};
//#endregion
export { templates };
